import React, { ReactElement } from 'react'
import { StyledSwitcher } from './styled'
import { IMultiToggleButton } from './MultiToggleButton'

export const MultiToggle = ({ activeValue, handleChange, children, theme }) => (
  <StyledSwitcher theme={theme}>
    {children.map(
      (Component: ReactElement<IMultiToggleButton>, index: number) =>
        React.cloneElement(Component, {
          key: index,
          active: activeValue === Component.props.value,
          onClick: (value: any) => {
            if (handleChange) {
              handleChange(value)
            }
          },
        })
    )}
  </StyledSwitcher>
)
